import styled from '@emotion/styled/macro'
const variants = {
    primary: {
        color: 'var(--colors-primary-text)',
        background: 'var(--colors-grays-80)',
    },
    primaryInverted: {
        color: 'var(--colors-primary-text)',
        background: 'var(--colors-grays-80)',
    },
}
const Button = styled('button')`
    /* background: ${({ label = 'primary' }) =>
        `var(--colors-${label}-main)`}; */
    background: ${({ background, variant = 'primary' }) =>
        background || variants[variant]?.background};
    color: ${({ color, variant = 'primary' }) =>
        color || variants[variant].color};

    font-size: var(--typography-fontSizes-p);
    user-select: none;
    /* font-weight: bold; */
    /* text-transform: uppercase; */
    text-decoration: none;
    text-align: center;
    align-items: center;
    border-radius: var(--borderRadius-sm);
    border: var(--borders-main);
    height: fit-content;
    ${({ fullWidth }) => (fullWidth ? 'width:100%;' : '')}
    padding: 0.5em 0.5em;

    transition: 0.25s ease all;
    &:hover {
        background-color: var(--colors-primary-accent);
        color: var(--colors-grays-80);
        /* font-weight: bold; */
    }
`

export const Link = styled('span')`
    text-decoration: underline;
    cursor: pointer;
    font-size: 1rem;
    user-select: none;
    margin-bottom: 0.5rem;
`
export const LinkButton = Link
export default Button
